import { Behavior } from '../../behaviourTree/Behavior';
import { TaskStatus } from '../../behaviourTree/TaskStatus';
/**
 * 检查组件是否存在的条件节点
 */
export class HasComponentCondition extends Behavior {
    constructor(componentType) {
        super();
        this.componentType = componentType;
    }
    update(entity) {
        try {
            const hasComponent = entity.hasComponent(this.componentType);
            return hasComponent ? TaskStatus.Success : TaskStatus.Failure;
        }
        catch (error) {
            console.error('检查组件时发生错误:', error);
            return TaskStatus.Failure;
        }
    }
}
/**
 * 添加组件的动作节点
 */
export class AddComponentAction extends Behavior {
    constructor(componentType, componentFactory) {
        super();
        this.componentType = componentType;
        this.componentFactory = componentFactory;
    }
    update(entity) {
        try {
            if (entity.hasComponent(this.componentType)) {
                return TaskStatus.Success; // 组件已存在
            }
            if (this.componentFactory) {
                const component = this.componentFactory();
                entity.addComponent(component);
            }
            else {
                entity.createComponent(this.componentType);
            }
            return TaskStatus.Success;
        }
        catch (error) {
            console.error('添加组件失败:', error);
            return TaskStatus.Failure;
        }
    }
}
/**
 * 移除组件的动作节点
 */
export class RemoveComponentAction extends Behavior {
    constructor(componentType) {
        super();
        this.componentType = componentType;
    }
    update(entity) {
        try {
            const component = entity.removeComponentByType(this.componentType);
            return component ? TaskStatus.Success : TaskStatus.Failure;
        }
        catch (error) {
            console.error('移除组件失败:', error);
            return TaskStatus.Failure;
        }
    }
}
/**
 * 检查实体标签的条件节点
 */
export class HasTagCondition extends Behavior {
    constructor(tag) {
        super();
        this.tag = tag;
    }
    update(entity) {
        return entity.tag === this.tag ? TaskStatus.Success : TaskStatus.Failure;
    }
}
/**
 * 操作组件属性的动作节点
 */
export class ModifyComponentAction extends Behavior {
    constructor(componentType, modifier) {
        super();
        this.componentType = componentType;
        this.modifier = modifier;
    }
    update(entity) {
        try {
            const component = entity.getComponent(this.componentType);
            if (!component) {
                return TaskStatus.Failure;
            }
            this.modifier(component);
            return TaskStatus.Success;
        }
        catch (error) {
            console.error('修改组件失败:', error);
            return TaskStatus.Failure;
        }
    }
}
/**
 * 等待指定时间的动作节点
 */
export class WaitTimeAction extends Behavior {
    constructor(waitTime) {
        super();
        this.waitTime = waitTime;
        this.startTime = 0;
        this.isStarted = false;
    }
    onStart() {
        this.startTime = performance.now();
        this.isStarted = true;
    }
    update(entity) {
        if (!this.isStarted) {
            return TaskStatus.Running;
        }
        const elapsed = (performance.now() - this.startTime) / 1000;
        return elapsed >= this.waitTime ? TaskStatus.Success : TaskStatus.Running;
    }
    onEnd() {
        this.isStarted = false;
    }
}
/**
 * 检查实体是否活跃的条件节点
 */
export class IsActiveCondition extends Behavior {
    constructor(checkHierarchy = true) {
        super();
        this.checkHierarchy = checkHierarchy;
    }
    update(entity) {
        const isActive = this.checkHierarchy ? entity.activeInHierarchy : entity.active;
        return isActive ? TaskStatus.Success : TaskStatus.Failure;
    }
}
/**
 * 销毁实体的动作节点
 */
export class DestroyEntityAction extends Behavior {
    update(entity) {
        try {
            entity.destroy();
            return TaskStatus.Success;
        }
        catch (error) {
            console.error('销毁实体失败:', error);
            return TaskStatus.Failure;
        }
    }
}
//# sourceMappingURL=ECSBehaviors.js.map